module.exports = __webpack_public_path__ + "img/card-template-cover-3d.27c5224c.png";